import { render, staticRenderFns } from "./SecurityView.vue?vue&type=template&id=26443971&"
import script from "./SecurityView.vue?vue&type=script&lang=ts&"
export * from "./SecurityView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26443971')) {
      api.createRecord('26443971', component.options)
    } else {
      api.reload('26443971', component.options)
    }
    module.hot.accept("./SecurityView.vue?vue&type=template&id=26443971&", function () {
      api.rerender('26443971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/member/security/SecurityView.vue"
export default component.exports